import React,{useState} from "react";
import {remove} from "../../redux/actions/hotel/afiPickupScheduleActions";
import {connect} from "react-redux";
import {CustomIconButton} from "../buttons/buttonsActions";


const TimeIndicator = (props) => {
    const {
        clazz = '',
        time = '',
        id = '',
        fbDataBaseId = '',
    } = props

    const [loading, setLoading] = useState(false)

    const changeLoading = () => setLoading(!loading)

    const onDelete = () => {
        setLoading(true)
        props.remove(id, fbDataBaseId, changeLoading)
    }


    return <div className={clazz}>
        <div className={'selected-hour'}>{time}</div>
        {
            loading
                ? <i className={'fa fa-spinner fa-spin'} />
                : <CustomIconButton
                    icon='fa fa-minus-circle'
                    clazz='btn-hour-selected'
                    onClick={onDelete}
                />
        }
    </div>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({remove,})

export default connect(mapStateToProps, mapActionsToProps)(TimeIndicator)